import { OpenIDConnectScheme } from '@nuxtjs/auth-next'
import type { AxiosRequestConfig } from 'axios'
import type { NuxtApp } from 'nuxt/app'
import { Interceptor } from '~/plugins/api/api-factory/interceptors/interceptor'
import { types } from '~/plugins/api/api-factory/interceptors/constants'

export class TokenInterceptor extends Interceptor {
  static TYPE = types.REQUEST

  constructor(protected readonly _nuxtApp: NuxtApp) {
    super()
  }

  onSuccess(request: AxiosRequestConfig) {
    if (this._hasToken) {
      request.headers.Authorization = this._token
    }

    return request
  }

  get _hasToken() {
    return this._token !== null && this._token.length > 0
  }

  get _token() {
    // Access $auth dynamically from nuxtApp to ensure we get the current auth state
    const auth = this._nuxtApp.$auth
    if (!auth?.loggedIn) return null
    return (auth.strategy as OpenIDConnectScheme).token.get() as string
  }
}
